import { DeleteOutline } from '@mui/icons-material';
import { Alert, Button, CircularProgress, Typography, useMediaQuery, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Rating from '@mui/material/Rating';
import { styled } from '@mui/material/styles';
import { arrayRemove, doc, setDoc } from 'firebase/firestore';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isStepNotComplete } from '../../common/utils';
import { UserField, UserInfo, UserProfileStep, UserSkill } from '../../consts/types/user';
import { db } from '../../firebase';
import { UserSelectors, userActionsCreators } from '../../reducers/user';
import ItemMenu from '../Common/ItemMenu';
import AddSkillDialog from './Dialogs/AddSkillDialog';
const { NotificationManager } = require('react-notifications');



const StyledRating = styled(Rating)({
    gap: 2,
    '& .MuiRating-iconFilled': {
        color: '#1976d2',
    },
    '& .MuiRating-iconHover': {
        color: '#3390ed',
    },
});


interface SkillsProps {

}

type Props = SkillsProps;


const Skills: FC<Props> = (props: Props) => {
    const user = useSelector(UserSelectors.currentUser);
    const dispatch = useDispatch();

    const [skills, setSkills] = useState(user?.skills || []);

    const [isSavingSkills, setIsSavingSkills] = useState(false);
    const [isAddingSkill, setIsAddingSkills] = useState(false);

    const [field, setField] = useState<UserField | "">(user?.field || "");
    const [hover, setHover] = useState<number>();
    // const [isUploadingAnswer, setIsUploadingAnswer] = useState(false);
    const [isSavingAnswers, setIsSavingAnswers] = useState(false);
    const [isSavingField, setIsSavingField] = useState(false);
    const [isSavingIdes, setIsSavingIdes] = useState(false);

    const [answers, setAnswers] = useState(user?.skillsTestLink || "");
    const [ides, setIdes] = useState(user?.ides || []);

    const backendTestUrl = "https://codesandbox.io/s/tik-tech-job-backend-test-7lcup2?fontsize=14&hidenavigation=1&theme=dark&file=/index.js";
    const frontendTestUrl = "https://codesandbox.io/s/tik-tech-job-frontend-test-lpthpg?from-embed=&file=/src/index.tsx";

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        setSkills(user?.skills || []);
    }, [user?.skills]);

    useEffect(() => {
        setAnswers(user?.skillsTestLink || "");
    }, [user?.skillsTestLink]);

    useEffect(() => {
        setField(user?.field || "");
    }, [user?.field]);

    useEffect(() => {
        setIdes(user?.ides || []);
    }, [user?.ides]);

    const removeSkill = (skill: UserSkill) => () => {
        if (user?.email) {
            const updatedSkills = skills.filter(s => s.skill !== skill.skill);
            setIsSavingSkills(true);
            if (user) {
                dispatch(userActionsCreators.setUser({ user: { ...user, skills: updatedSkills } }));
            }
            setDoc(doc(db, "users", user.email), {
                skills: arrayRemove(skill),
                skillsNames: arrayRemove(skill.skill),
            }, { merge: true })
                .then((result) => {
                    setIsSavingSkills(false);
                    NotificationManager.success('Changes were saved successfully!',);
                })
                .catch(() => {
                    setIsSavingSkills(false);
                    NotificationManager.error('Something went wrong. Please try again.',);
                });
        }
    }

    const save = (fieldsToUpdate: Partial<UserInfo>) => () => {
        if (!user) {
            return;
        }
        if (fieldsToUpdate.skillsTestLink) {
            setIsSavingAnswers(true);
        }
        else if (fieldsToUpdate.field) {
            setIsSavingField(true);
        }
        else if (fieldsToUpdate.ides) {
            setIsSavingIdes(true);
        }
        if (Object.values(fieldsToUpdate).every(value => !!value)) {
            setDoc(doc(db, "users", user.email), {
                ...fieldsToUpdate
            }, { merge: true })
                .then((result) => {
                    if (user) {
                        dispatch(userActionsCreators.setUser({ user: { ...user, ...fieldsToUpdate } }));
                    }
                    NotificationManager.success('Changes were saved successfully!',);
                    setIsSavingAnswers(false);
                    setIsSavingField(false);
                    setIsSavingIdes(false);
                })
                .catch(() => {
                    setIsSavingAnswers(false);
                    setIsSavingField(false);
                    setIsSavingIdes(false);
                    NotificationManager.error('An error occurred.',);
                });
        }
    }
    return <Box borderRadius="4px" >
        {isStepNotComplete(UserProfileStep.SkillsTest) && <Alert severity='warning' sx={{ display: { xs: "flex", md: "none" } }}>Step is not completed yet</Alert>}
        {<Box  >
            <Box borderRadius="4px" sx={{ overflowY: "auto" }} >
                {/* <Box mb={3} display="flex" flexDirection="column" gap={3}> */}
                {/* <Box >
                        <Box display="flex" alignItems="center" mb={2}>
                            <Typography color="primary"  >Field of Expertise</Typography>
                            {isSavingField && <CircularProgress sx={{ width: "18px !important", height: "18px !important", ml: 1, color: "primary" }} />}
                        </Box>
                        <Box display="flex" gap={1}>
                            <FormControl fullWidth size="small" required>
                                <InputLabel >Field</InputLabel>
                                <Select label="Degree" value={field} onChange={(e) => { save({ field: (e.target.value  || "") as any })(); setField(e.target.value as UserField); }} >
                                    {Object.values(UserField).map(field => <MenuItem key={field} value={field}>{field}
                                    </MenuItem>)}
                                </Select>
                            </FormControl>
                            
                        </Box>

                    </Box> */}

                {/* </Box> */}
                {/* <Divider /> */}
                {/* <Box display="flex" alignItems="center">
                    <Typography color="primary" mb={2} mt={3}>Development Environments</Typography>
                    {isSavingIdes && <CircularProgress sx={{ width: "18px !important", height: "18px !important", ml: 1, color: "primary" }} />}
                </Box> */}
                {/* <FormControl fullWidth size="small" required sx={{ mb: 3 }}>
                    <Autocomplete multiple
                        disableCloseOnSelect
                        value={ides}
                        onChange={(e, newValue) => { save({ ides: newValue })(); setIdes(newValue); }}
                        options={orderBy(IDEs, ide => ide, ["asc"])}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                label="IDEs"
                                InputProps={{
                                    ...params.InputProps,
                                }}
                            />
                        )} />
                </FormControl> */}
                {/* <Divider /> */}
                <Card variant="outlined">
                    <CardContent>
                        <Box display="flex" justifyContent="space-between" alignItems="center" >
                            <Box display="flex" alignItems="center">
                                <Typography color="primary" fontWeight={500} >SKILLS</Typography>
                                {isSavingSkills && <CircularProgress sx={{ width: "18px  !important", height: "18px !important", ml: 1 }} />}
                            </Box>
                            <Button variant="outlined" size="small" onClick={() => { setIsAddingSkills(true) }}>+ Add </Button>
                        </Box>

                        <Box display="flex" flexWrap="wrap" justifyContent="space-between" flexDirection={{ xs: "column", md: "row" }}>
                            {skills?.map((skill, index) => <Card key={skill.skill + index} sx={{ mt: 2, flex: "0 0 47%" }} variant="outlined">
                                <CardContent sx={{ paddingBottom: "16px !important" }}>
                                    <Box display="flex" justifyContent="space-between">
                                        <Box display="flex" flexDirection="column">
                                            <Box display="flex" gap={2} alignItems="center">
                                                <Typography color="text.primary" fontWeight={400} fontSize={{ xs: "1rem", md: "1.1rem" }} component="div">
                                                    {skill.skill}
                                                </Typography>
                                                {/* <StyledRating size="small" max={3}
                                            value={skill.level}
                                            precision={1}
                                            getLabelText={getRatingLabelText}
                                        /> */}

                                            </Box>
                                            <Typography color="text.secondary" fontSize={{ xs: "0.8rem !important", md: "0.875rem !important" }} mt={0.3} >
                                                {`${skill.years} years`}
                                            </Typography>

                                        </Box>
                                        <Box display="flex" gap={2}>
                                            {/* <Typography fontWeight={500} color={getFieldStatusColor(skill.status,)} fontSize={{ xs: "0.7rem", md: "0.875rem" }} component="div" mt={0.5}>
                                        {skill.status}
                                    </Typography> */}
                                            <ItemMenu items={[{
                                                label: "Delete",
                                                icon: <DeleteOutline fontSize='small' color="inherit" />,
                                                onClick: removeSkill(skill)
                                            }]} />
                                        </Box>
                                    </Box>

                                </CardContent>
                            </Card>)}
                        </Box>
                    </CardContent>
                </Card>
            </Box>


        </Box>}
        {/* <Divider />
        <Typography color="primary" mt={3}>Skills Test</Typography>
        <Box display="flex" justifyContent="center" my={3}>
            <Button color="primary" variant="contained" size="small"
                href={field === UserField.Frontend ? frontendTestUrl : backendTestUrl} target="_blank"
                sx={{ mr: 2 }}
                disabled={skills.length === 0}>
                Take The Test
            </Button>
            <Button color="primary" variant="outlined" size="small"
                href={field === UserField.Frontend ? frontendTestUrl : backendTestUrl}
                target="_blank"
                disabled={skills.length === 0}>
                Take A Short Test
            </Button>
        </Box>
        <Box mb={3} display="flex" flexDirection="column" gap={3}>
            <Box >
                <Typography fontSize="0.9rem" mb={1} >Test Answers</Typography>
                <Typography mb={2} fontSize="0.85rem" color="text.secondary">Fork the test repository on CodeSandbox and copy a link to your answers</Typography>
                <Box display="flex" gap={1} mb={2}>
                    <TextField size="small" type="text" value={answers} onChange={e => setAnswers(e.target.value)} label="Link to your fork" fullWidth required />
                    <Box display="flex" justifyContent={{ xs: "center", md: "flex-end" }}>
                        <Button variant="outlined" disabled={isSavingAnswers}
                            // sx={{ backgroundColor: "#0f4687", color: "white", "&:hover": { backgroundColor: "#1d6bca" } }}
                            onClick={save({ skillsTestLink: answers })}>
                            {isSavingAnswers && <CircularProgress sx={{ width: "18px !important", height: "18px !important", mr: 1, color: "inherit" }} />}
                            SAVE
                        </Button>
                    </Box>
                </Box>

            </Box>

        </Box> */}
        <AddSkillDialog isAddingSkill={isAddingSkill}
            isSavingSkills={isSavingSkills}
            setIsAddingSkills={setIsAddingSkills}
            setIsSavingSkills={setIsSavingSkills} />
    </Box>
        ;
}


export default Skills;

